/**
 * MedicLynkOS pulse mark, reused as the portal's logo (same paths/colors as
 * app/assets/icon-template.svg) so the portal reads as the same product family as the mobile
 * app rather than shipping a second, drifting brand mark. Inline SVG, not a PNG import — crisp
 * at any size and small enough not to matter for bundle weight.
 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      role="img"
      aria-label="MedicLynk"
    >
      <circle cx="512" cy="512" r="342" fill="none" stroke="#0B0F14" strokeWidth="58" />
      <path
        d="M286 512H410L462 424L552 600L612 512H738"
        fill="none"
        stroke="#68D4E5"
        strokeWidth="36"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon fill="#68D4E5" points="648,415 683,450 648,485 613,450" />
    </svg>
  );
}
